export default __webpack_public_path__ + "static/media/p8.7a5384e2.png";